import React, { ReactNode } from 'react';
import './modal-dialog-style.scss';
import { AppDialog } from '../dialog/app-dialog';
import { AppButton, AppButtonType, AppButtonVariant } from '../buttons/app-button';

export interface ModalDialogProps {
  open: boolean;
  title?: string;
  subtitle?: string;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  children?: ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ModalDialog = (props: ModalDialogProps) => {
  const { open = false, title, subtitle, cancelButtonLabel, confirmButtonLabel, children, onClose, onConfirm, onCancel } = props;

  return (
    <AppDialog open={open} onClose={onClose}>
      <div className='modal-dialog'>
        <div className='title-section'>
          {title && <div className='title'>{title}</div>}
          {subtitle && <div className='subtitle'>{subtitle}</div>}
        </div>

        {children && <div className='content-section'>{children}</div>}

        <div className='button-section'>
          {cancelButtonLabel && (
            <AppButton type={AppButtonType.BUTTON} variant={AppButtonVariant.Primary} label={cancelButtonLabel || 'Annulla'} onClick={onCancel} />
          )}
          {confirmButtonLabel && (
            <AppButton type={AppButtonType.BUTTON} variant={AppButtonVariant.Primary} label={confirmButtonLabel || 'Conferma'} onClick={onConfirm} />
          )}
        </div>
      </div>
    </AppDialog>
  );
};
